export default __webpack_public_path__ + "static/media/holdsetting.d8b9e1b5.png";